import { DataGrid } from "@mui/x-data-grid";

const UncheckedIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="13" height="13" rx="1.5" fill="white" stroke="#DAE4D5"/>
  </svg>
)

const CheckedIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="13" height="13" rx="1.5" fill="#F3FFEB" stroke="#4CBC18"/>
    <path d="M3.5 7L5.5 9.5L10.5 4.5" stroke="#4CBC18" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const PipelineGrid = ({
  rows,
  columns,
  selectedRows,
  onRowSelectionChange,
}) => {
  return (
    <div className="w-full overflow-hidden rounded-[24px] bg-white border border-[#DCEBD4]">
      <DataGrid
        rows={rows}
        columns={columns}
        rowSelectionModel={{ type: 'include', ids: new Set(selectedRows) }}
        onRowSelectionModelChange={(model) => {
            if (model?.type === 'include') {
                onRowSelectionChange([...model.ids]);
            } else {
                onRowSelectionChange([]);
            }
        }}
        checkboxSelection
        disableColumnMenu
        disableRowSelectionOnClick
        hideFooter
        autoHeight
        rowHeight={76}
        slotProps={{
          baseCheckbox: {
            icon: <UncheckedIcon />,
            checkedIcon: <CheckedIcon />,
          },
        }}
        sx={{
          border: "none",
          fontFamily: 'Figtree',
          '--DataGrid-rowBorderColor': '#DAE4D5',
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#DCEBD4",
            borderBottom: "none",
          },

          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: 14,
            fontWeight: 700,
            color: "#17270D",
          },

          "& .MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center",
            outline: "none !important",
          },

          "& .MuiDataGrid-row": {
            backgroundColor: "#FFFFFF",
          },

          "& .MuiDataGrid-row.Mui-selected": {
            backgroundColor: "#E8F5E1",
          },

          "& .MuiDataGrid-row.Mui-selected:hover": {
            backgroundColor: "#E8F5E1",
          },

          "& .MuiCheckbox-root": {
            padding: "5px",
            "&:hover": { backgroundColor: "transparent" },
          },

          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },

          "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell': {
            padding: '0 !important', 
          },
        }}
      />
    </div>
  );
};

export default PipelineGrid;
